module.exports = {
	"footprint": {
		"low": 90.96087751666754,
		"avg": 142.93505917008576,
		"high": 184.20627263623436,
		"veryHigh": 314.88973634654246
	},
	"intensity": {
		"low": 146.27081815747613,
		"avg": 175.19842249504092,
		"high": 219.1781911001236,
		"veryHigh": 411.7265809951513
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/data/FootprintRanges.json
// module id = 961
// module chunks = 0